import React from 'react';
import { CardContent } from '@mui/material';

const DSCardContent = (props: React.ComponentProps<typeof CardContent>) => {
  return <CardContent {...props} />;
};

export default DSCardContent;
